import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div<{ $scrollAuto: boolean }>`
  padding: ${({ theme }) => `${theme.spacing(4)} 0`};

  ${({ $scrollAuto }) =>
    $scrollAuto &&
    css`
      height: 100%;
      overflow: auto;
    `};
`;

export const InteractionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;
